"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputBase = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var InputBase_1 = tslib_1.__importDefault(require("@material-ui/core/InputBase"));
var defaultTo_1 = tslib_1.__importDefault(require("lodash/fp/defaultTo"));
exports.InputBase = function (_a) {
    var name = _a.name, id = _a.id, backgroundColor = _a.backgroundColor, _b = _a.multiline, multiline = _b === void 0 ? false : _b, rest = tslib_1.__rest(_a, ["name", "id", "backgroundColor", "multiline"]);
    var nameOrId = defaultTo_1.default(name, id);
    return (react_1.default.createElement(StyledInput, tslib_1.__assign({}, rest, { backgroundColor: backgroundColor, id: nameOrId, classes: {
            focused: 'focused',
            disabled: 'disabled',
            error: 'error',
            input: 'input',
        }, multiline: multiline })));
};
exports.InputBase.displayName = 'FOS_InputBase';
var StyledInput = styled_components_1.default(InputBase_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  && {\n    background-color: ", ";\n    padding-left: 2.4rem;\n    border: ", ";\n    border-radius: 0;\n    height: auto;\n    min-height: ", ";\n    align-items: ", ";\n    padding-left: 0.7rem;\n    padding-right: 0rem;\n  }\n  &&.focused {\n    border: ", ";\n  }\n  &&.disabled {\n    opacity: 0.4;\n  }\n  &&.error {\n    border: ", ";\n  }\n  && .input {\n    background-color: ", ";\n    font-family: ", ";\n    font-size: 1.3rem;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.38;\n    letter-spacing: normal;\n    color: ", ";\n  }\n"], ["\n  && {\n    background-color: ", ";\n    padding-left: 2.4rem;\n    border: ", ";\n    border-radius: 0;\n    height: auto;\n    min-height: ", ";\n    align-items: ", ";\n    padding-left: 0.7rem;\n    padding-right: 0rem;\n  }\n  &&.focused {\n    border: ", ";\n  }\n  &&.disabled {\n    opacity: 0.4;\n  }\n  &&.error {\n    border: ", ";\n  }\n  && .input {\n    background-color: ", ";\n    font-family: ", ";\n    font-size: 1.3rem;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.38;\n    letter-spacing: normal;\n    color: ", ";\n  }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : undefined;
}, function (_a) {
    var theme = _a.theme;
    return "thin solid " + theme.colors.NTDarkGrey[200];
}, function (_a) {
    var multiline = _a.multiline;
    return (multiline ? '6.4rem ' : '3.2rem');
}, function (_a) {
    var multiline = _a.multiline;
    return (multiline ? 'baseline' : 'center');
}, function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.colors.green[500] + " !important";
}, function (_a) {
    var theme = _a.theme;
    return "thin solid " + theme.colors.red[500];
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : undefined;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoRegular;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
});
var templateObject_1;
